"use client";

import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { MessageSquare, X, ArrowRight } from "lucide-react";
import Link from "next/link";

const options = [
  { label: "Build with AI", href: "/services/artificial-intelligence" },
  { label: "Modernize Software", href: "/services/enterprise-software" },
  { label: "Move to Cloud", href: "/services/cloud-devops" },
  { label: "Automate Operations", href: "/solutions" },
  { label: "Build Data Platform", href: "/services/data-engineering" },
  { label: "Explore Consulting", href: "/services/it-consulting" },
];

export function AiAssistant() {
  const [open, setOpen] = useState(false);

  return (
    <div className="fixed bottom-[max(1rem,env(safe-area-inset-bottom))] right-[max(1rem,env(safe-area-inset-right))] z-[70] max-w-[calc(100vw-2rem)] sm:bottom-5 sm:right-5">
      <AnimatePresence>
        {open ? (
          <motion.div
            initial={{ opacity: 0, y: 16, scale: 0.96 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 12, scale: 0.96 }}
            className="mb-3 max-h-[min(70vh,32rem)] w-[min(100%,360px)] overflow-y-auto overflow-x-hidden rounded-[1.75rem] border border-border bg-background-elevated shadow-[var(--shadow-soft)]"
          >
            <div className="sticky top-0 border-b border-border bg-gradient-to-r from-accent/15 to-cyan/10 px-4 py-3.5 sm:px-5 sm:py-4">
              <div className="flex items-start justify-between gap-3">
                <div>
                  <p className="text-sm font-medium">Maxridge Guide</p>
                  <p className="mt-1 text-xs text-muted">What are you looking to transform?</p>
                </div>
                <button
                  type="button"
                  aria-label="Close assistant"
                  onClick={() => setOpen(false)}
                  className="rounded-full border border-border p-1.5"
                >
                  <X className="h-4 w-4" />
                </button>
              </div>
            </div>
            <div className="space-y-2 p-3">
              {options.map((option) => (
                <Link
                  key={option.label}
                  href={option.href}
                  onClick={() => setOpen(false)}
                  className="flex items-center justify-between rounded-2xl border border-border px-3 py-2.5 text-sm transition hover:border-accent/40 hover:bg-card sm:px-4 sm:py-3"
                >
                  {option.label}
                  <ArrowRight className="h-4 w-4 shrink-0 text-muted" />
                </Link>
              ))}
              <Link
                href="/contact"
                onClick={() => setOpen(false)}
                className="mt-2 flex items-center justify-center rounded-2xl bg-foreground px-4 py-3 text-sm font-medium text-background"
              >
                Start a project inquiry
              </Link>
            </div>
          </motion.div>
        ) : null}
      </AnimatePresence>

      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="inline-flex h-12 items-center justify-center gap-2 rounded-full border border-border bg-foreground px-3.5 text-sm font-medium text-background shadow-[var(--shadow-glow)] sm:h-14 sm:px-5"
        aria-expanded={open}
        aria-label="Open Maxridge assistant"
      >
        <MessageSquare className="h-4 w-4" />
        <span className="hidden min-[380px]:inline">Ask Maxridge</span>
        <span className="min-[380px]:hidden">Ask</span>
      </button>
    </div>
  );
}
